import { render, staticRenderFns } from "./advertiseSpace.vue?vue&type=template&id=ebfdf57e&scoped=true"
import script from "./advertiseSpace.vue?vue&type=script&lang=js"
export * from "./advertiseSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebfdf57e",
  null
  
)

export default component.exports